<template>
  <div>
        <div class="occupation header breadcrumbs-absolute" :class="{'occupationPC':$store.state.innerWidth>768}">
        <Breadcrumbs></Breadcrumbs>
        <div class="searchOccupations">
            <!-- <img v-bind:src="backgroundImg" /> -->
            <div class="warp-mask"></div>
            <div class="occupation-contain">
                <div class="searchContent occupation-opportunityPC col-sm-10 col-md-12">
                    <h2 class="Bold">{{ $t("message.Careers Exploration") }}</h2>
                    <div class="row">
                        <div class="col-md-4 col-lg-5 pad-10 pad-r-35">
                            <div class="input-group">
                                <b class="i-left">
                                    <i class="icon-search gray" aria-hidden="true"></i>
                                </b>
                                <input 
                                    type="text"  
                                    @keydown.enter="searchFn" 
                                    v-on:click="clickKeyword()" 
                                    v-model="keyword" 
                                    v-bind:placeholder="$t('message.OccupationTitleSkillOrIndustry')" 
                                    class="input-one" 
                                    autocomplete="off" 
                                    :aria-label="$t('message.OccupationTitleSkillOrIndustry')"
                                />
                                <b class="i-right" v-if="keyword" @click="clearEvent">
                                    <i class="icon-close-1 gray" aria-hidden="true"></i>
                                </b>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-5 pad-10 pad-r-35" :class="{'show':showEducationLevel}">
                            <div class="input-group" @click="openEducationLevel" role="combobox" :aria-label="$t('message.All Education Level')">
                                <b class="i-left">
                                    <i class="icon-box gray" aria-hidden="true"></i>
                                </b>
                                <div class="input-two allInput " style="text-align:left;">
                                    <a href="javascript:;" style="color: inherit">
                                    <span  class="oneline-box"  v-if="!educationLevelDisplay" >{{$t('message.All Education Level')}}</span>
                                    <span  class="oneline-box" v-else >{{educationLevelDisplay}}</span>
                                    </a>
                                </div>
                                <b class="i-right">
                                    <i class="icon-arrow-down mainColor" aria-hidden="true"></i>
                                </b>
                            </div>
                            <div class="criteria-content can-scroll multi-layer criteria-job-func show-choice margin-r-25" :class="{'show':showEducationLevel}" style="text-align: left;top: 5px;">
                                <ul>
                                    <li class="item-table" v-on:click="selectAllEducationLevelFn()" role="option" :aria-label="$t('message.All Education Level')">
                                        <div class="tdcell">
                                            <a href="javascript:;" style="color: inherit">{{$t('message.All Education Level')}}</a>
                                        </div>
                                        <div class="tdcell width-25 text-right">
                                            <span class="check-box " :class="selectedAllEducationLevel?'checked':''"></span>
                                        </div>
                                    </li>
                                    <li class="item-table" v-for="(education,index) in educationList" v-on:click="selectEducationLevelFn(education)" role="option" :aria-label="$store.getters.getContent(education.name)">
                                        <div class="tdcell">
                                            <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(education.name)}}</a>
                                        </div>
                                        <div class="tdcell width-25 text-right">
                                            <span class="check-box " :class="education.selected?'checked':''"></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-2 pad-10 ">
                            <div class="search-btn">
                                <div class="btn btn-primary" v-on:click="searchFn()" role="button" :aria-label="$t('message.Search')">
                                    <a href="javascript:;" style="color: inherit">{{$t('message.Search')}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" @click="closePopup" :class="{'show':showEducationLevel,'maskPC':$store.state.innerWidth>768}"></div>
        <div class="occupation-contain">
            <div class="occupation-opportunityPC col-sm-10 col-md-8 padLeft-0 padRight-0">
                <JobFunctionList ref="Jbf" v-bind:childLogGaEvent="childLogGaEvent" v-if="!isFilter&&!$route.params.magazineId" v-bind:jobFunction="jobFunction" class="jobFunctionList" v-for="(jobFunction,index) in jobFunctions" :index="index"></JobFunctionList>
                <div class="jobFunction active" v-if="isFilter&&!$route.params.magazineId">
                    <Occupations v-bind:childLogGaEvent="childLogGaEvent" v-bind:keyword="keywordData"  v-bind:educationLevel="educationIdsData" class="occupations"></Occupations>
                </div>
                <div class="jobFunction active" v-if="$route.params.magazineId">
                    <Occupations v-bind:childLogGaEvent="childLogGaEvent" v-bind:magazineId="$route.params.magazineId" class="occupations"></Occupations>
                </div>
            </div>
       
        </div>
        
    </div>
    <div class="occupation breadcrumbs-absolute">
        <div class="occupation-contain">
            <div class="occupation-opportunityPC col-sm-10 col-md-8 occupation-bottom">
                <div class="powered-by powered-by-browseOccupations Bold">
                    {{$t('message.Powered by')}} 
                </div>
                <div class="occupation-bottom-imgPlace">
                    <div class="vtc">
                        <a href="https://occupation-dictionary.vtc.edu.hk" target="_blank"  v-if="$store.state.language == 'en_US'"><img :src="VTC" alt="VTC LOGO"></a>
                        <a href="https://occupation-dictionary.vtc.edu.hk/tc" target="_blank"  v-if="$store.state.language == 'zh_HK'"><img :src="VTC" alt="VTC 標誌"></a>
                        <a href="https://occupation-dictionary.vtc.edu.hk/sc" target="_blank"  v-if="$store.state.language == 'zh_CN'"><img :src="VTC" alt="VTC 标志"></a>
                    </div>
                    <div class="inBlue">    
                        <a href=" https://www.linkedin.com" target="_blank" ><img :src="inBlue" alt="inBlue LOGO"></a>
                    </div>
                
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<!--<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import JobFunctionList from '@/components/JobFunctionList'
import Occupations from '@/components/Occupations'
import VTC from '../images/VTC logomark colour.jpg'
import inBlue from '../images/inBlue.png'

export default {
    name:"browseOccupations",
    components: {
        Breadcrumbs,
        JobFunctionList,
        Occupations
    },
    props:[
        "logGaEvent"
    ],
    data() {
        return {
            totalRows: 0,
            jobFunctions: [],
            keyword: "",
            keywordData:"",
            showEducationLevel: false,
            educationLevelDisplay: '',
            selectedAllEducationLevel: false,
            isFilter: false,
            educationList: [],
            educationIds:"",
            educationIdsData:"",
            // backgroundImg: "",
            VTC:VTC,
            inBlue:inBlue,
            fromLouterName:'',
        }
    },   
    created() {
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword;
            this.searchFn();
        }
    },
    watch: {
        '$route.query.keyword' (newKeyword){
            if(newKeyword){
                this.keyword = newKeyword;
                this.searchFn();
            }
        }
    },
    methods: {
        childLogGaEvent:function(eventCategory, eventAction, eventLabel, eventValue) {
            this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue)
        },
        openEducationLevel: function() {
            this.logGaEvent('userClick','filterBrowseOccupations','Education Level')
            this.showEducationLevel = !this.showEducationLevel;
            if (this.comment.getType()) {
                this.isMobile = true;
            }
        },
        selectAllEducationLevelFn: function() {
            let that = this
            this.logGaEvent('userSelect','educationLevel','All Education Level')
            that.selectedAllEducationLevel = !that.selectedAllEducationLevel
            that.educationList.map(function(v, i) {
                v.selected = that.selectedAllEducationLevel;
                return v
            });
        },
        defaultSearchFn: function() {
            this.isFilter = false;
            var that = this
            let data = {}

            that.api.getJobFunctionList(data, function(data) {
                that.totalRows = data.totalRows;
                that.jobFunctions = data.result;
            })

        },
        searchFn: function() {
            this.logGaEvent('search','filterBrowseOccupations',this.keyword)
            this.isFilter = (this.keyword||this.educationIds)
            if(this.isFilter){
                this.keywordData=this.keyword
                this.educationIdsData=this.educationIds
            }

            this.$router.push({
                path: '/browseOccupations',
                query: {
                    lang: this.$route.query.lang || this.$i18n.locale,
                    keyword: this.keyword
                }
            })

            let data = { keyword: this.keyword, educationIds: this.educationIds};

            let that = this;
            that.api.getJobFunctionList(data, function(response) {
                that.totalRows = response.totalRows;
                that.jobFunctions = response.result;
            });
        },
        getEducationListFn: function() {
            var that = this
            that.api.getEducationList({}, function(data) {
                that.educationList = data.result.map(function(v, i) { 
                    var ids = [];
                    if(that.educationIds){
                        ids = that.educationIds.split(',')
                    }
                    v.selected = false; 
                    for(var i=0;i<ids.length;i++){
                        if(v.id==ids[i]){
                            v.selected = true;
                        }
                    }
                    return v 
                });
            })
        },
        selectEducationLevelFn: function(obj) {
            this.logGaEvent('userSelect','educationLevel',this.$store.getters.getContent(obj.name))
            obj.selected = !obj.selected;
            let selectedEducation = this.educationList.filter(education => education.selected)

            this.selectedAllEducationLevel = (selectedEducation.length == this.educationList.length)
        },
        clickKeyword:function(){
            this.logGaEvent('userClick','filterBrowseOccupations','Keyword')
        },
        closePopup:function(){
            this.showEducationLevel = false;
        },
        clearEvent:function(){
            this.keyword = ""
            this.searchFn();
        },
    },
    beforeRouteLeave(to, from, next){ 

    
        // this.fromLouterName = to.name;
        
        if(to.name=='occupationDetails'){
            // from.meta.isUseCache = true;
        }else{
            // to.meta.isUseCache = true;
        }
            next()
    },
    beforeRouteEnter(to, from, next){ 

    
      
       
        if(from.name=='occupationDetails'){
            to.meta.isUseCache = false;
        }else{
             to.meta.isUseCache = true;
        }
            next()
    },
     activated(){
        this.$store.state.selectMenu = 2;
        this.$store.state.mate.title = this.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title");
        this.$store.state.mate.description = this.$i18n.t("message.Careers_desc");
        this.$store.state.mate.keywords = this.$i18n.t("message.Careers_keywords");
    
        if(this.jobFunctions.length==0||this.$store.state.formData.headTabState2){
      
            
            var that = this;
            this.$store.state.formData.headTabState2 = false;
          
            this.keyword = '';
            this.educationLevel = '';
            this.keywordData="";
            this.showEducationLevel = false,
            this.educationLevelDisplay = '';
            this.selectedAllEducationLevel = false;
            this.isFilter = false;
           
            this.educationList = [];
            this.educationIds = '';

            this.defaultSearchFn();
           
            this.title = this.$i18n.t("message.Browse Occupations")
            // this.
            this.getEducationListFn()
            // searchFn
            
        }
        
  },
    mounted() {
        var that = this
        setTimeout(function(){
          that.$store.state.mate.title = that.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+that.$i18n.t("message.Default Page Title");
          that.$store.state.mate.keywords = that.$i18n.t("message.Careers_keywords");
        })
        this.$store.state.selectMenu = 2;
        if(this.$route.meta.isUseCache){
        
        this.defaultSearchFn();
        this.title = this.$i18n.t("message.Browse Occupations")

        // this.
        this.getEducationListFn()
        // searchFn
        }
    },
    watch: {
        educationList: {
            handler: function(val, oldval) {
                let that=this

                let selectedEducations=that.educationList.filter(education=>education.selected)

                this.selectedAllEducations=(selectedEducations.length==this.educationList.length)
                if(that.selectedAllEducations){
                    this.educationLevelDisplay=this.$i18n.t('message.All Education Level')
                }else{
                    this.educationLevelDisplay=selectedEducations.map(
                        function(v,i){return that.$store.getters.getContent(v.name)}
                    ).join(',')//title , title
                }
                this.educationIds=selectedEducations.map(function(v,i){return v.id}).join(',')

                
            },
            deep: true
        }
    }



}
</script>-->
<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import JobFunctionList from '@/components/JobFunctionList'
import Occupations from '@/components/Occupations'
import VTC from '../images/VTC logomark colour.jpg'
import inBlue from '../images/inBlue.png'

export default {
  name: "browseOccupations",
  components: {
    Breadcrumbs,
    JobFunctionList,
    Occupations
  },
  props: ["logGaEvent"],
  data() {
    return {
      totalRows: 0,
      jobFunctions: [],
      keyword: "",
      keywordData: "",
      showEducationLevel: false,
      educationLevelDisplay: '',
      selectedAllEducationLevel: false,
      isFilter: false,
      educationList: [],
      educationIds: "",
      educationIdsData: "",
      VTC,
      inBlue,
      fromLouterName: '',
      selectedAllEducations: false // used in educationList watcher
    }
  },

  created() {
    const keyword = (this.$route.query && this.$route.query.keyword) || '';
    const lang = (this.$route.query && this.$route.query.lang) || this.$i18n.locale;

    if (keyword) {
      this.keyword = keyword;
      this.fetchResult(keyword, lang);
    } else {
      this.defaultSearchFn();
    }
  },

  watch: {
    '$route'(to) {
      const keyword = (to.query && to.query.keyword) || '';
      const lang = (to.query && to.query.lang) || this.$i18n.locale;
      this.keyword = keyword;
      this.fetchResult(keyword, lang);
    },
    educationList: {
      handler(val) {
        const selectedEducations = val.filter(e => e.selected);
        this.selectedAllEducations = (selectedEducations.length === val.length);
        this.educationLevelDisplay = this.selectedAllEducations
          ? this.$i18n.t('message.All Education Level')
          : selectedEducations.map(v => this.$store.getters.getContent(v.name)).join(',');
        this.educationIds = selectedEducations.map(v => v.id).join(',');
      },
      deep: true
    }
  },

  methods: {
    childLogGaEvent(eventCategory, eventAction, eventLabel, eventValue) {
      if (typeof this.logGaEvent === 'function') {
        this.logGaEvent(eventCategory, eventAction, eventLabel, eventValue);
      }
    },

    // Fix: add click handler used by the input
    clickKeyword() {
      this.childLogGaEvent('userClick', 'filterBrowseOccupations', 'Keyword');
    },

    // searchFn() {
    //   const lang = (this.$route.query && this.$route.query.lang) || this.$i18n.locale;
    //   const keyword = this.keyword || '';

    //   if ((this.$route.query && this.$route.query.keyword) !== keyword) {
    //     this.$router.push({
    //       path: '/browseOccupations',
    //       query: { lang, keyword }
    //     }).catch(() => {});
    //   }

    //   this.fetchResult(keyword, lang);
    // },
    searchFn() {
    const trimmedKeyword = this.keyword ? this.keyword.trim() : '';

    // If typing a keyword, require at least 2 or 3 characters before searching.
    // Allow empty string if user clears the input.
    if (trimmedKeyword.length === 1) {
      return; // Stop execution on 1 character
    }

    const lang = (this.$route.query && this.$route.query.lang) || this.$i18n.locale;

    // Update URL query parameters
    if ((this.$route.query && this.$route.query.keyword) !== trimmedKeyword) {
      this.$router.push({
        path: '/browseOccupations',
        query: { lang, keyword: trimmedKeyword }
      }).catch(() => {});
    }

    this.fetchResult(trimmedKeyword, lang);
  },
    

    fetchResult(keyword, lang) {
      const data = { keyword, educationIds: this.educationIds };

      // Ensure this.api is available (in main.js: Vue.prototype.api = apiService)
      if (!this.api || !this.api.getJobFunctionList) {
        console.error('API service not available: this.api.getJobFunctionList');
        return;
      }

      this.api.getJobFunctionList(data, response => {
        this.totalRows = response.totalRows;
        this.jobFunctions = response.result;
      });

      if (typeof this.logGaEvent === 'function') {
        this.logGaEvent('search', 'filterBrowseOccupations', keyword);
      }

      // keep UI flags in sync
      this.isFilter = !!(keyword || this.educationIds);
      if (this.isFilter) {
        this.keywordData = keyword;
        this.educationIdsData = this.educationIds;
      }
    },

    defaultSearchFn() {
      if (!this.api || !this.api.getJobFunctionList) {
        console.error('API service not available: this.api.getJobFunctionList');
        return;
      }
      this.api.getJobFunctionList({}, data => {
        this.totalRows = data.totalRows;
        this.jobFunctions = data.result;
      });
    },

    getEducationListFn() {
      if (!this.api || !this.api.getEducationList) {
        console.error('API service not available: this.api.getEducationList');
        return;
      }

      this.api.getEducationList({}, data => {
        const ids = (this.educationIds || '').split(',');
        this.educationList = data.result.map(v => {
          v.selected = ids.includes(String(v.id));
          return v;
        });
      });
    },

    // clearEvent() {
    //   this.keyword = "";
    //   this.searchFn();
    // },
    clearEvent() {
    this.keyword = "";
    // Directly reset to default view or invoke default search
    this.defaultSearchFn();
    this.isFilter = false;

    // Clean up query param from URL
    const lang = (this.$route.query && this.$route.query.lang) || this.$i18n.locale;
    this.$router.push({ path: '/browseOccupations', query: { lang } }).catch(() => {});
  },

    openEducationLevel() {
      this.childLogGaEvent('userClick', 'filterBrowseOccupations', 'Education Level');
      this.showEducationLevel = !this.showEducationLevel;
      // Removed this.comment.getType() to avoid undefined errors
    },

    selectAllEducationLevelFn() {
      this.childLogGaEvent('userSelect', 'educationLevel', 'All Education Level');
      this.selectedAllEducationLevel = !this.selectedAllEducationLevel;
      this.educationList = this.educationList.map(v => ({ ...v, selected: this.selectedAllEducationLevel }));
    },

    selectEducationLevelFn(obj) {
      this.childLogGaEvent('userSelect', 'educationLevel', this.$store.getters.getContent(obj.name));
      obj.selected = !obj.selected;
      const selectedEducation = this.educationList.filter(e => e.selected);
      this.selectedAllEducationLevel = (selectedEducation.length === this.educationList.length);
    },

    closePopup() {
      this.showEducationLevel = false;
    }
  },

  activated() {
    this.$store.state.selectMenu = 2;
    this.$store.state.mate.title = this.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title");
    this.$store.state.mate.description = this.$i18n.t("message.Careers_desc");
    this.$store.state.mate.keywords = this.$i18n.t("message.Careers_keywords");

    const hasKeyword =
      !!(this.$route && this.$route.query && this.$route.query.keyword);

    if ((this.jobFunctions.length === 0 || this.$store.state.formData.headTabState2) && !hasKeyword) {
      this.$store.state.formData.headTabState2 = false;
      this.defaultSearchFn();
      this.getEducationListFn();
    }
  },

  mounted() {
    setTimeout(() => {
      this.$store.state.mate.title = this.$i18n.t("message.Careers_title")+" - talent.gov.hk - "+this.$i18n.t("message.Default Page Title");
      this.$store.state.mate.keywords = this.$i18n.t("message.Careers_keywords");
    });
    this.$store.state.selectMenu = 2;

    const hasKeyword =
      !!(this.$route && this.$route.query && this.$route.query.keyword);

    if (this.$route.meta && this.$route.meta.isUseCache && !hasKeyword) {
      this.defaultSearchFn();
      this.getEducationListFn();
    }
  },

  beforeRouteLeave(to, from, next) {
    next();
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === 'occupationDetails') {
      to.meta.isUseCache = false;
    } else {
      to.meta.isUseCache = true;
    }
    next();
  }
}
</script>
